import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=b70d1e2e&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style0 from "./Order.vue?vue&type=style&index=0&id=b70d1e2e&scoped=true&lang=css&"
import style1 from "./Order.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70d1e2e",
  null
  
)

export default component.exports